import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Hero } from '@/components/marketing/Hero';
import { Features, HowItWorks, Problems } from '@/components/marketing/Features';
import { Testimonials } from '@/components/marketing/Testimonials';
import { PricingSection } from '@/components/marketing/PricingSection';
import { CTASection, UrgencyCTA } from '@/components/marketing/CTASection';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Hero />
        <Problems />
        <HowItWorks />
        <Features />
        <Testimonials />
        <PricingSection />
        <CTASection />
        <UrgencyCTA />
      </main>
      <Footer />
    </div>
  );
}
